import { OPTION_FIELD_TYPES } from '../constants/formStudioFieldTypes';
import { isStatusField, isSubStatusField } from './formStudioFormUtils';
import { isUiStatusField } from './fieldTypeAdapter';

const HEX_COLOR = /^#[0-9A-Fa-f]{6}$/;

export function shouldShowFieldOptionsPreview(field) {
  if (!field) return false;
  if (isUiStatusField(field) || isStatusField(field) || isSubStatusField(field)) {
    return true;
  }
  return OPTION_FIELD_TYPES.includes(field.key_type);
}

export function normalizeFieldOptions(keyOptions) {
  if (!Array.isArray(keyOptions)) {
    return [];
  }
  return keyOptions.map((option) => String(option || '').trim()).filter(Boolean);
}

/** Legacy parity: merge picked and previous option colors for saved options. */
export function mergeOptionColors(uniqueOptions, info, fallbackColors = {}) {
  const pickedColors = info?.option_colors ?? {};
  const prevColors = info?.attribute?.option_colors ?? fallbackColors ?? {};
  const nextColors = {};

  uniqueOptions.forEach((option) => {
    const fromPicked = pickedColors[option];
    const fromPrev = prevColors[option];
    if (fromPicked && HEX_COLOR.test(fromPicked)) {
      nextColors[option] = fromPicked;
    } else if (fromPrev && HEX_COLOR.test(fromPrev)) {
      nextColors[option] = fromPrev;
    }
  });

  return nextColors;
}

export function formatFieldOptionsSummary(keyOptions, maxVisible = 3) {
  const options = normalizeFieldOptions(keyOptions);
  if (options.length === 0) {
    return null;
  }

  const visible = options.slice(0, maxVisible);
  const remaining = options.length - visible.length;
  const text = visible.join(' · ');
  return remaining > 0 ? `${text} · +${remaining} more` : text;
}
